<!-- eslint-disable -->
<template lang="pug">
    .form
        .form__container
            .form__title
                | {{ pageTitle }}
            form.form__body(
                action="javascript://"
                @submit="submitForm"
            )
                .form__field
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_themeName') }}
                    .form__field-body
                        cs-input(
                            :erorr="errors.has('name')",
                            type='text',
                            v-model='theme.name',
                            name='name',
                            v-validate="'required'",
                            :data-vv-as="$i18n.t('presentations.presentations_form_themeName').toLowerCase()",
                            :disabled='isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport'
                        )
                        help-text(v-if="errors.has('name')", error)
                            | {{ errors.first('name') }}
                .form__field
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_presentations') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :options='presentations',
                            :show-labels='false',
                            :allow-empty='true',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingPresentations',
                            @open='getPresentations',
                            v-model='theme.presentations',
                            data-vv-value-path='innerValue',
                            data-vv-name='presentation',
                            :data-vv-as="$i18n.t('presentations.presentations_form_presentations')",
                            :disabled='loadingPresentations || (isEducationMaterial && !user.isSuperadmin && !user.isManagerOrSupport)'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('presentations.presentations_form_presentationsNotFound') }}
                        help-text(v-if="errors.has('presentation')", error)
                            | {{ errors.first('presentation') }}
                .form__field(v-if='isVisibleOnlyToMeOptionAvailable')
                    label.form__label
                        | {{ $i18n.t('presentations.presentations_form_visibleOnlyToMe') }}
                    .form__field-body
                        cs-checkbox(v-model='theme.visibleOnlyToMe')
                .form__field(v-if='user.isSuperadmin || user.isManagerOrSupport || !this.isEducationMaterial')
                    label.form__label
                        | {{ $i18n.t('homework.homework_create_school') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :options='schools',
                            :show-labels='false',
                            :allow-empty='!!user.isSuperadmin || !!user.isManagerOrSupport',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingSchools',
                            @open='getSchools',
                            v-model='theme.schools',
                            :v-validate='validationRules',
                            data-vv-value-path='innerValue',
                            data-vv-name='school',
                            :data-vv-as="$i18n.t('homework.homework_create_schoolVvSs')",
                            :disabled='loadingSchools || theme.visibleOnlyToMe'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('homework.homework_create_schoolNotFound') }}
                        help-text(v-if="errors.has('school')", error)
                            | {{ errors.first('school') }}
                .form__field(v-if='user.isSuperadmin || user.isManagerOrSupport')
                    label.form__label
                    .form__field-body
                        help-text(slot='help-text', v-text=" $i18n.t('billing.billing_stocks_schoolsHelper')")
                .form__field(v-if="user.type === 'admin' && !user.isSuperadmin && isEducationMaterial")
                    label.form__label
                        | {{ $i18n.t('homework.homework_create_grade') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple='true',
                            :options='grades',
                            :close-on-select='false',
                            :show-labels='false',
                            :allow-empty='true',
                            :placeholder="$i18n.t('common.common_placeholder_enterToSearch')",
                            label='name',
                            track-by='id',
                            :searchable='true',
                            :loading='loadingGrades',
                            @open='getGrades',
                            v-model='theme.grades',
                            :v-validate='validationRules',
                            data-vv-value-path='innerValue',
                            data-vv-name='grade',
                            :data-vv-as="$i18n.t('homework.homework_create_gradeVvSs')",
                            :disabled='loadingGrades || theme.visibleOnlyToMe'
                        )
                            span(slot='noResult')
                                | {{ $i18n.t('homework.homework_create_gradeNotFound') }}
                        help-text(v-if="errors.has('grade')", error)
                            | {{ errors.first('grade') }}
                .form__field(v-if="user.type === 'admin' && !user.isSuperadmin && isEducationMaterial")
                    label.form__label
                    .form__field-body
                        help-text(slot='help-text', v-text=" $i18n.t('presentations.presentations_form_gradesHelper')")
                .form__buttons
                    cs-button.form__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                    )
                        | {{ $i18n.t('homework.homework_create_save') }}
                    cs-button.form__button(
                        color="blue"
                        pattern="primary-outline"
                        @click.prevent="$router.back()"
                    )
                        | {{ $i18n.t('common.common_button_cancel') }}
</template>

<script>
    /*eslint-disable*/
    import { cloneDeep } from "lodash";
    import PresentationApi from "../../../api/games/presentationsApi";
    import PresentationsThemesApi from "../../../api/games/presentationThemeApi";
    import { mapState } from "vuex";
    import SchoolApi from "../../../api/school";
    import GradeApi from '../../../api/grade'

    export default {
        props: {
            copy: {
                type: Object,
                default: null,
            },
            page: {
                type: [String, Number],
            },
            id: {
                type: [Number, String],
            },
        },
        mounted () {
            this.fetchData();
        },
        data () {
            return {
                theme: {
                    name: '',
                    presentations: [],
                    schools: [],
                    grades: [],
                    visibleOnlyToMe: false,
                },
                isLoading: false,
                loadingPresentations: false,
                presentations: [],
                loadingSchools: false,
                loadingGrades: false,
                schools: [],
                grades: [],
            }
        },
        methods: {
            fetchData () {
                this.isEducationMaterial && !this.user.isSuperadmin && !this.user.isManagerOrSupport
                        ? this.getGrades()
                        : this.getSchools();
                if (this.copy) {
                    this.theme = cloneDeep(this.copy);
                    if (!this.isEducationMaterial || this.user.isSuperadmin || this.user.isManagerOrSupport) {
                        this.$set(this.theme, 'visibleOnlyToMe', this.theme.usersFilterType === 'only_creator');
                    } else {
                        this.$set(this.theme, 'visibleOnlyToMe', !this.theme.grades.some(grade => this.user.schoolsIds.includes(grade.schoolId)));
                    }
                    if (this.isEducationMaterial) {
                        this.theme.grades = this.theme.grades.filter(grade => this.user.schoolsIds.includes(grade.schoolId));
                    }
                } else if (this.id) {
                    PresentationsThemesApi.show(this.id)
                    .then(data => {
                        this.theme = data.theme;
                        if (this.isEducationMaterial && !this.user.isSuperadmin && !this.user.isManagerOrSupport) {
                            this.$set(this.theme, 'visibleOnlyToMe', !this.theme.grades.some(grade => this.user.schoolsIds.includes(grade.schoolId)));
                        }
                        if (this.isEducationMaterial) {
                            this.theme.grades = this.theme.grades.filter(grade => this.user.schoolsIds.includes(grade.schoolId));
                        }
                    })
                    .catch(err => {
                        this.showErrorMessage(err)
                    })
                }
            },
            getSchools() {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                SchoolApi.list({
                    all: true,
                    withActiveAccount: !this.isEducationMaterial,
                }).then(data => {
                    let schools = data.schools;
                    this.schools = schools ? schools : [];
                    this.loadingSchools = false;
                }).catch(() => {
                    this.loadingSchools = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getGrades() {
                if (this.grades.length) {
                    return;
                }
                this.loadingGrades = true;
                GradeApi.list({
                    schoolsIds: _.intersectionBy(this.user.schools, this.theme.schools || [], 'id'),
                    all: true,
                    status: 'active',
                }).then(data => {
                    let grades = data.grades;
                    this.grades = grades ? grades : [];
                    this.loadingGrades = false;
                }).catch(err => {
                    this.loadingGrades = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            getPresentations() {
                if (this.presentations.length) {
                    return;
                }
                this.loadingPresentations = true;
                PresentationApi.list({
                    all: true,
                    isEducationMaterial: this.isEducationMaterial
                }).then(data => {
                    let presentations = data.presentations;
                    this.presentations = presentations ? presentations : [];
                    this.loadingPresentations = false;
                }).catch(() => {
                    this.loadingPresentations = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            showErrorMessage (err) {
                this.isLoading = false;
                if (err.data) {
                    let location = this.isEducationMaterial
                            ? { name: 'education-materials:main' }
                            : { name: 'create:game', query: {slug: 'Presentations'} }
                    this.$router.push( location);
                    this.$toasted.error(err.message);
                }
                err = (err.response && err.response.data) ? err.response.data : err;
                if (err && (err.status_code === 403 || err.status_code === 404)) {
                    this.$router.push({ name: 'dashboard' });
                    this.$toasted.error(err.message);
                }
            },
            submitForm () {
                this.$validator.validateAll()
                .then((isValid) => {
                    if (isValid) {
                        if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                          this.theme.presentationsIds = this.theme.presentations.map(presentation => presentation.id);
                          this.theme.schoolsIds = this.theme.schools.map(school => school.id);
                        }
                        this.theme.isEducationMaterial = this.isEducationMaterial;
                        if (this.isEducationMaterial && !this.user.isSuperadmin && !this.user.isManagerOrSupport) {
                            if (this.theme.grades.length) {
                                this.theme.gradesIds = this.theme.grades.map(grade => grade.id);
                            } else if (!this.theme.visibleOnlyToMe) {
                                this.theme.gradesIds = this.grades.map(grade => grade.id);
                            } else {
                                this.theme.gradesIds = [];
                            }
                        }
                        this.isLoading = true;
                        this.$nextTick(() => {
                            delete this.theme.presentations;
                            delete this.theme.schools;
                            delete this.theme.grades;
                        });
                        if (this.copy) {
                            delete this.theme.id;
                            delete this.theme.updatedAt;
                            delete this.theme.createdAt;
                        }
                        let params = +this.id ? {id: +this.id, theme: this.theme} : this.theme;
                        PresentationsThemesApi[+this.id ? 'update' : 'create'](params)
                        .then(() => {
                            let location = this.isEducationMaterial
                                    ? { name: 'education-materials:main' }
                                    : { name: 'create:game', query: {slug: 'Presentations'} }
                            this.$router.push( location);
                        })
                        .catch(err => this.showErrorMessage(err));
                    }
                });
            },
        },
        watch: {
            'theme.visibleOnlyToMe': {
                handler (val) {
                    if (val) {
                        this.isCreator && (this.theme.schools = []);
                        this.theme.grades = []
                    }
                }
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            }),
            pageTitle () {
                return !this.id
                        ? this.$i18n.t('presentations.presentations_theme_createTitle')
                        : this.$i18n.t('presentations.presentations_theme_updateTitle');
            },
            validationRules () {
                if (this.user.isSuperadmin || this.user.isManagerOrSupport) {
                    return '';
                }
                return 'required';
            },
            isEducationMaterial () {
                if (this.copy) {
                    return !!this.copy.isEducationMaterial;
                }
                return this.$route.name.includes('education-material');
            },
            isVisibleOnlyToMeOptionAvailable () {
                return !this.isEducationMaterial ? Boolean(this.isCreator) : Boolean(this.theme);
            },
            isCreator () {
                return this.copy ? this.user.id === this.copy.userId : true;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form__container {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .form {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__games {
        margin: 0 0 0 auto;
        width: 100%;
    }

    .form__input {
        margin-bottom: 0;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--bold {
        font-weight: 500;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .warning {
        display: flex;
        align-items: center;
        font-size: $font-size-16;
        line-height: $font-size-16;
    }

    .warning__icon {
        color: $hsl-color-red-62;
        margin-right: 8px;
    }

    .form__textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0,0%,4%,.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 180px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .game-preview {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .game-preview__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include stack-space($space-small);
    }

    .game-preview__title {
        display: flex;
        align-items: center;
    }

    .game-preview__image {
        vertical-align: middle;
        margin-bottom: 12px;
        &:last-child {
            margin-right: 0;
        }
        @include media($sm) {
            margin: 0 12px 0 0;
            &:last-child {
                margin: 0;
            }
        }
    }

    .game-preview__parameters {
        margin-bottom: 12px;
        &:last-child {
            margin-right: 0;
        }
    }

    .game-preview__icon {
        color: $hsl-color-green-58;
        background-color: transparent;

        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .game-preview__button {
        display: flex;
        align-items: center;
    }

    .button__icon {
        margin-right: $space-x-small;
    }
</style>
